import Vue from 'utils/vueUtils';
import { baseApi } from 'core/api';
import { useToastStore } from 'store/modules';

const state = () => ({
    _twoFAuth: [],
    _twoFAuthLoading: false,
    _twoFAuthOrganizationEnable: false,
    _twoFAuthShowModal: false,
    _twoFAuthShowModalItem: null,
    _twoFAuthShowModalType: null,
});

const getters = {
    twoFAuth: (state) => {
        const twoFAuthMethods = state._twoFAuth.map((item) => {
            if (item.type === 'email' && state._twoFAuthOrganizationEnable) {
                return {
                    ...item,
                    value: true,
                    disabled: true,
                };
            }

            return item;
        });

        return twoFAuthMethods;
    },
    twoFAuthEnable: (state) => state._twoFAuth.filter((item) => item.value),
    twoFAuthLoading: (state) => state._twoFAuthLoading,
    twoFAuthOrganizationEnable: (state) => state._twoFAuthOrganizationEnable,
    twoFAuthShowModal: (state) => state._twoFAuthShowModal,
    twoFAuthShowModalItem: (state) => state._twoFAuthShowModalItem,
    twoFAuthShowModalType: (state) => state._twoFAuthShowModalType,
};

const actions = {
    updateTwoFAuthState(data) {
        this._setTwoFAuthUpdateState(data);
    },

    updateTwoFAuthLogin({ form }) {
        return form.post('core/2fa/auth/login').then((response) => {
            const data = response.data;

            const token = data.token?.access_token;

            // Multiorgs flow
            if (token) {
                const [, tokenData] = token.split('.');
                const parsedData = JSON.parse(atob(tokenData));

                if (!parsedData.oid) {
                    return data;
                }
            }

            const is2fa = data.data.is_2fa;
            const settings = data.data.settings;

            if (is2fa && settings) {
                const settingsEnabled = settings.filter((item) => item.value);
                const item = settingsEnabled.length ? settingsEnabled[0] : settings[0];

                this._setTwoFAuthInitSettings(settings);
                this._setTwoFAuthUpdateState({
                    twoFAuthShowModal: true,
                    twoFAuthShowModalItem: item,
                    twoFAuthShowModalType: 'login',
                });
            }
            window.localStorage.setItem('firstLogin', 'true');
            window.sessionStorage.setItem('newSession', 'true');
            return data;
        });
    },

    getTwoFAuthSettings({ loading = true } = {}) {
        if (loading) {
            this._setTwoFAuthUpdateState({ twoFAuthLoading: true });
        }

        return baseApi
            .get('core/2fa')
            .then((response) => {
                this._setTwoFAuthInitSettings(response.data);

                return response.data;
            })
            .finally(() => {
                this._setTwoFAuthUpdateState({ twoFAuthLoading: false });
            });
    },

    createTwoFAuthAuthSend({ params }) {
        return baseApi
            .post('core/2fa/auth/send', params)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response?.data;
            });
    },

    getTwoFAuthQrCode() {
        return baseApi.get('core/2fa/qr-code').then((response) => {
            return response.data;
        });
    },

    createTwoFAuthSend({ params }) {
        return baseApi
            .post('core/2fa/send', params)
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: error.response?.data?.message,
                });
            })
            .then((response) => {
                return response.data;
            });
    },

    updateTwoFAuthAuthVerify({ params }) {
        return baseApi
            .post('core/2fa/auth/verify', params)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
    },

    updateTwoFAuthVerify({ params }) {
        return baseApi.post('core/2fa/verify', params).then((response) => {
            const message = response.data.message;

            if (message) throw { message: message };

            this._setTwoFAuthInitSettings(response.data);

            return response.data;
        });
    },

    updateTwoFAuthOrganization(form) {
        return form.post('core/2fa/organization').then((response) => {
            this._setTwoFAuthUpdateState({
                twoFAuthOrganizationEnable: form.value,
            });

            return response.data;
        });
    },

    handleShowModalTwoFAuth({ status = false, item = null, type = null }) {
        this._setTwoFAuthUpdateState({
            twoFAuthShowModal: status,
            twoFAuthShowModalItem: item,
            twoFAuthShowModalType: type,
        });
    },

    _setOrganization(organization) {
        this._twoFAuthOrganizationEnable = Boolean(organization.two_fa_enabled);
    },

    _setTwoFAuthInitSettings(data) {
        const sort = {
            sms: 0,
            email: 1,
            app: 2,
        };

        this._twoFAuth = data.sort((a, b) => {
            const aValue = sort[a.type];
            const bValue = sort[b.type];
            return aValue - bValue;
        });
    },

    _setTwoFAuthUpdateSettings(data) {
        const index = this._twoFAuth.findIndex((item) => item.type === data.type);
        const item = this._twoFAuth[index];

        Vue.set(this._twoFAuth, index, {
            ...item,
            ...data,
        });
    },

    _setTwoFAuthUpdateState(data) {
        for (let key in data) {
            this[`_${key}`] = data[key];
        }
    },
};

export default {
    state,
    getters,
    actions,
};
